import { isIndiaCountry } from './region';

type CountryReadyInput = {
  userCountry?: string | null;
  detectedCountry?: string | null;
  detectionSettled: boolean;
  isIOSAppEnvironment: boolean;
};

export const normalizeCountryCode = (country?: string | null): string | null => {
  const code = (country || '').trim().toUpperCase();

  return /^[A-Z]{2}$/.test(code) ? code : null;
};

export const resolveBillingCountry = (
  userCountry?: string | null,
  detectedCountry?: string | null,
): string | null => normalizeCountryCode(userCountry) || normalizeCountryCode(detectedCountry);

export const isCountryReadyForPricing = ({
  userCountry,
  detectedCountry,
  detectionSettled,
  isIOSAppEnvironment,
}: CountryReadyInput): boolean => (
  isIOSAppEnvironment
  || Boolean(resolveBillingCountry(userCountry, detectedCountry))
  || detectionSettled
);

export const getDefaultPricingCurrency = (
  billingCountry?: string | null,
  isIOSAppEnvironment = false,
): 'USD' | 'INR' => (
  isIndiaCountry(billingCountry) && !isIOSAppEnvironment ? 'INR' : 'USD'
);
